import { useApi } from "@utils/useApi";
import { TenantSwitchClient, SwitchTenantRequest } from "@lib/ShiOneClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ms from "ms";

export const UserTenantsQKey = "user-tenants";

export function useGetUserTenants(enabled = true) {
  const api = useApi(TenantSwitchClient);

  return useQuery({
    queryKey: [UserTenantsQKey],
    queryFn: () => api.getMyTenants(),
    // Rendered by the persistent nav; tenant membership rarely changes mid-session.
    staleTime: ms("30m"),
    enabled,
  });
}

export function useSwitchTenant() {
  const api = useApi(TenantSwitchClient);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tenantId: string) => {
      const request = new SwitchTenantRequest();
      request.tenantId = tenantId;
      return await api.switchTenant(request);
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [UserTenantsQKey] }),
  });
}
